import BaseInput from 'components/inputs/BaseInput';
import Label from 'components/inputs/Label';
import React, { useState } from 'react';
import { getSubmittalSpecInfo } from 'services/submittalService';
import { useTranslator } from '@bluebeam/react-i18n';

const regex = /(([0-9]\s*([.][0-9]*)*){2}){3}/g;

interface Props {
  id: string;
  defaultSpecNumber: string;
  defaultSpecName?: string;
  onSpecNumberChange: (val: string) => void;
  onSpecNameChange?: (val: string) => void;
}

const SpecInfoFields: React.FC<Props> = (props) => {
  const [specNumber, setSpecNumber] = useState<string>(props.defaultSpecNumber);
  const [specName, setSpecName] = useState<string>(props.defaultSpecName || '');
  const { translate } = useTranslator(['submittalsPage']);

  const handleSpecNumberChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    const match = value.match(regex);

    if (match) {
      if (value === match[0]) {
        setSpecNumber(value.trimEnd());
        props.onSpecNumberChange(value);

        const valueWithoutSpaces = value.replace(/\s+/g, '');
        getSubmittalSpecName(valueWithoutSpaces);
      }
    } else {
      setSpecName('');
      setSpecNumber(value);
    }
  };

  const getSubmittalSpecName = async (value: string): Promise<void> => {
    let specName = '';

    try {
      const { specname } = await getSubmittalSpecInfo(value);

      specName = specname;
    } catch (err) {
      specName = ''; // redundant, but need to put something in catch block.
    } finally {
      setSpecName(specName);
      if (props.onSpecNameChange) {
        props.onSpecNameChange(specName);
      }
    }
  };
  const { id } = props;

  return (
    <>
      <div className="mb3">
        <Label label={translate('submittalsPage:specNumberFull')} required />
        <BaseInput
          id={`${id}-specnumber`}
          value={specNumber}
          onChange={handleSpecNumberChange}
          valueAlwaysFromProps
        />
      </div>
      <div className="mb3">
        <Label label={translate('submittalsPage:specSection')} />
        <BaseInput id={`${id}-specname`} value={specName} disabled />
      </div>
    </>
  );
};

export default SpecInfoFields;
